import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Toaster } from 'react-hot-toast';
import App from './App';

const container = document.getElementById('root');

if (!container) {
  throw new Error("React root element doesn't exist!");
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
    <Toaster />
  </StrictMode>,
);
